import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { GratisItem } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';
import { ConfirmComponent } from '../confirm/confirm.component';

@Component({
  selector: 'lib-productsgratis',
  templateUrl: './productsgratis.component.html',
  styleUrls: ['./productsgratis.component.scss']
})
export class ProductsgratisComponent implements OnInit {

  gratis: GratisItem[] = [];

  sortLoading: boolean = false;

  constructor(
    private las: ApiService,
    private dialogService: DialogService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getProductsGratisList();
  }

  getProductsGratisList(): void {
    this.las.getProductsGratisList().subscribe(({gratis}) => {
      this.gratis = gratis;
    });
  }

  deleteGratis(id: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Grátisz törlése',
        text: 'Biztosan törölni szeretnéd ezt a grátiszt?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      this.las.deleteProductsGratis(id).subscribe(() => {
        this.getProductsGratisList();
      });
    });
  }

  up(index: number): void {
    this.sortLoading = true;
    const gratisIds: number[] = this.gratis.map((gratisItem: GratisItem) => gratisItem.gratisId);
    const a: number = gratisIds[index];
    gratisIds[index] = gratisIds[index - 1];
    gratisIds[index - 1] = a;
    this.sort(gratisIds);
  }

  down(index: number): void {
    this.sortLoading = true;
    const gratisIds: number[] = this.gratis.map((gratisItem: GratisItem) => gratisItem.gratisId);
    const a: number = gratisIds[index];
    gratisIds[index] = gratisIds[index + 1];
    gratisIds[index + 1] = a;
    this.sort(gratisIds);
  }

  sort(ids: number[]): void {
    this.las.sortProductsGratis(ids).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Sorbarenzedés',
        detail: 'Sikeres mentés!'
      });
      this.getProductsGratisList();
      this.sortLoading = false;
    });
  }

}
